import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, race } from 'rxjs';
import { defaultIfEmpty, map, switchMap, take } from 'rxjs/operators';
import { currentEncounterId, isEmptyEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { DiagnosesState } from '../../entities';
import { DiagnosesApi } from '../../infrastructure';
import { DiagnosesAction } from '../actions';

/**
 * Diagnoses effects
 */
@Injectable()
export class DiagnosesEffects {
    /* Effect Declarations */

    /**
     * Load diagnoses effect
     */

    loadDiagnoses$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DiagnosesAction.loadDiagnosesAction.action),
            switchMap(action =>
                race(
                    isEmptyEncounterId(this.store).pipe(
                        take(1),
                        map(() => DiagnosesAction.loadDiagnosesAction.clearAction()),
                    ),
                    from(
                        makeDefaultAsyncActionEffect(
                            this.diagnosesApi
                                .getDiagnoses(action.encounterId)
                                .pipe(isSameEncounterFilter(currentEncounterId(this.store), action.encounterId)),
                            DiagnosesAction.loadDiagnosesAction,
                        ),
                    ).pipe(defaultIfEmpty(DiagnosesAction.loadDiagnosesAction.clearAction())),
                ),
            ),
        ),
    );

    /**
     * Constructor
     * @param actions$ Actions
     * @param diagnosesApi DiagnosesApi
     * @param store
     */
    constructor(
        private actions$: Actions,
        private diagnosesApi: DiagnosesApi,
        private store: Store<DiagnosesState>,
    ) {}
}
